import { RadioArray } from "controls/radioArray";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Card, Col, Row } from "react-bootstrap";
import FuelViewModel from "viewModels/eshop/order/components/fuelViewModel";
import { registerView } from "@frui.ts/views";
import fuelEcoIcon from "utils/fuelEcoIcon";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import Tooltip from "controls/tooltip";
import { isMobile } from "react-device-detect";

const FuelTypeView: FunctionComponent<{
  vm: FuelViewModel;
}> = observer(({ vm }) => {
  const chargeOrderFuelItem = vm.chargeOrderFuelItem;
  const isSelected = chargeOrderFuelItem.fuelTypeId === vm.fuelTypeItem.id;
  const infoTooltipTranslate = (code: string) => vm.localizationService.translateGeneral(`eshop.infoTooltip.${code}`);

  const labelContent = (
    <Card.Body className="test d-flex align-items-center pl-3 pl-sm-4 py-0 pr-1 pr-sm-3">
      <Row>
        <Col className="pt-sm-1 pt-lg-1 pt-xl-0 pl-xl-1 pl-xxl-2">
          <Row className="d-flex align-items-center">
            <Col xs={12} sm={6} xl={12} className="d-flex align-items-center">
              {!vm.isOtherType && (
                <img
                  className="mr-2"
                  style={{ width: "1rem", height: "1rem" }}
                  src={fuelEcoIcon(vm.fuelTypeItem.fuelType)}
                  alt={""}
                />
              )}
              <h5 className="m-0">{vm.translateAttribute(vm.fuelTypeItem.fuelType)}</h5>
              {vm.isOtherType && (
                <Tooltip
                  id="license-plate-tooltip"
                  show={vm.displayTooltip}
                  trigger="click"
                  placement={isMobile ? "auto" : "right-start"}
                  onClose={vm.closeTooltip}
                  tooltip={infoTooltipTranslate("OTHER")}>
                  <span className="px-2" style={{ zIndex: 10 }} onClick={vm.showTooltip}>
                    <Icon className="cursor-pointer" icon={IconType.MiniInfo} width={16} height={16} />
                  </span>
                </Tooltip>
              )}
            </Col>
            {vm.isTypeWithDescription && (
              <Col xs={12} sm={6} xl={12}>
                <span className="d-flex align-self-center m-0">
                  {vm.translateAttribute(`${vm.fuelTypeItem.fuelType}_DESCRIPTION`)}
                </span>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Card.Body>
  );

  const radioId = `${vm.chargeFuelType}-${vm.batchIndex ?? 0}`;
  return (
    <Card
      className={"mt-3 fuel-view " + (isSelected ? " border-success" : "") + (vm.error ? " border-danger" : "")}
      style={{
        backgroundColor: isSelected ? "rgba(1, 177, 99, 0.1)" : "transparent",
      }}>
      <RadioArray
        custom
        label={labelContent}
        className={"fuel-type-select d-flex align-items-center label-stretch pl-0"}
        name={"fuelType"}
        target={chargeOrderFuelItem}
        property="fuelTypeId"
        isNumeric={false}
        id={radioId}
        option={vm.fuelTypeItem.id}
        isInvalid={!!vm.error}
        disabled={vm.isDisabledFuelType}
      />
    </Card>
  );
});

registerView(FuelTypeView, FuelViewModel);
